import { useEffect, useState } from "react";
import { specialOfferApi } from "@rshbintech.dboul/http";

export const useMarkAsRead = () => {
  const [data, setData] = useState<string[]>([]);
  const [error, setError] = useState();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      specialOfferApi.api
        .markAsRead(data)
        .catch((error) => {
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [data, isLoading]);

  const markAsReadCallback = (data: string[]) => {
    setLoading(true);
    setData(data);
  };

  return {
    error,
    isLoading,
    markAsReadCallback,
  };
};
